import ActionTypes from "../../enums/ActionTypes"
import { setExactDeliveryDateOfOrderPositions } from "./helpers/conflicts"
import { initialState } from "./initialState"

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.PLANNING_OBJECTS_OPERATION_DETAILS_UPDATE_SUCCESS: {
      const { operation } = action.payload
      const nextState = {
        ...state,
        operations: {
          ...state.operations,
          [operation.operationId]: {
            ...state.operations[operation.operationId],
            workerId: operation.workerId,
          },
        },
      }
      return nextState
    }
    case ActionTypes.PLANNING_OBJECTS_ORDER_POSITION_DETAILS_UPDATE_SUCCESS: {
      const {
        data: [
          {
            orderPosition: { orderPositionId, deliveryDate },
          },
        ],
      } = action.payload
      const nextState = {
        ...state,
        orderPositions: {
          ...state.orderPositions,
          [orderPositionId]: {
            ...state.orderPositions[orderPositionId],
            deliveryDate,
          },
        },
      }
      setExactDeliveryDateOfOrderPositions(nextState)

      return nextState
    }
    default:
      return state
  }
}
